import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { createPasswordResetFormSchema } from './passwordResetSchema';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export type PasswordResetFormValues = z.infer<
  ReturnType<typeof createPasswordResetFormSchema>
>;

const usePasswordResetForm = () => {
  const { t } = useTranslation();
  const schema = createPasswordResetFormSchema(t);
  const form = useForm<PasswordResetFormValues>({
    mode: 'onChange',
    resolver: zodResolver(schema),
    criteriaMode: 'all',
    defaultValues: {
      password: '',
    },
  });

  useEffect(() => {
    if (form.formState.isSubmitted) {
      form.trigger();
    }
  }, [t]);

  return {
    form,
  };
};

export { usePasswordResetForm };
